import styled from "@emotion/styled";
import { Container } from "@mui/material";
const MenuContainer = styled.div`
  width: 100%;
  z-index: 9999;
  transition: all linear 0.3s;
  /* position: sticky; */
  top: 0;
  background-color: #24272a;
  /* background-color: ${(props) =>
    props.isSticky == "sticky" ? "black" : ""}; */
  padding: ${(props) => (props.isSticky == "sticky" ? "" : "1px 0")};
  box-shadow: ${(props) =>
    props.isSticky == "sticky" ? "0px 3px 7px rgba(0, 0, 0, 0.51)" : ""};
  img {
    width: ${(props) => (props.isSticky == "80px !important" ? "" : "")};
  }
  @media (max-width: 899px) {
    position: absolute;
    backdrop-filter: blur(10px);
  }
`;
const DesktopMainMenu = styled(Container)`
  padding: 10px 0px;
  /* padding: 15px 0; */
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 899px) {
    display: none;
  }
`;
const MobileMainMenu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;

  @media (min-width: 900px) {
    display: none;
  }
  @media (max-width: 900px) {
    padding: 5px 10px;
  }
`;
const SiteLogo = styled.img`
  width: 100%;
  height: auto;
  max-width: 200px;
`;
const MenuLink = styled.a`
  word-break: keep-all;
  display: flex;
  align-items: center;
  font-family: "poppins-light";
  font-size: max(15px, 17px);
  font-weight: bolder;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  cursor: pointer;
  transition-duration: 0.5s;
  &:nth-child(4) {
    background-color: #d4a204;
    color: #fff;
    border-radius: 24px;
    padding: 10px 30px 10px 30px;
    font-family: "poppins-light";
    font-size: 14px;
    box-shadow: ${(props) =>
      props.bs ? props.bs : "inset 0px 2px 5px 0px white"};
    &:hover {
      /* color: black; */
      opacity: 0.8;
    }
    @media screen and (max-width: 899px) {
      display: none;
    }
  }
  &:hover,
  &:active,
  &:focus {
    color: #ffffff;
    transition-duration: 0.5s;
  }
  @media (max-width: 899px) {
    display: block;
    padding: 15px 0 15px 2%;
    border-bottom: 1px solid #1a1a1a;
    text-align: left;

    &:nth-child(1) {
      padding-top: 25px;
    }
  }
`;

export { MenuContainer, DesktopMainMenu, MobileMainMenu, MenuLink, SiteLogo };
